(() => {
  if (window.pwMobileDetailsSequence) return;
  window.pwMobileDetailsSequence = true;
  let pending = false;
  function arrange() {
    pending = false;
    document.querySelectorAll('#MainContent [id^="ProductInfo-"]').forEach(info => {
      const quote = Array.from(info.children).find(node => node.classList.contains('pw-testimonial-link'));
      const details = Array.from(info.children).filter(node => node.classList.contains('product__accordion'));
      if (!quote || !details.length) return;
      const last = details[details.length - 1];
      if (last.nextElementSibling !== quote) last.after(quote);
    });
  }
  function schedule() {
    if (!pending) {
      pending = true;
      queueMicrotask(arrange);
    }
  }
  function start() {
    arrange();
    const root = document.getElementById('MainContent');
    if (root) new MutationObserver(schedule).observe(root, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('shopify:section:load', schedule);
})();